/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TriState } from './TriState';
import {
    instanceOfTriState,
    TriStateFromJSON,
    TriStateFromJSONTyped,
    TriStateToJSON,
} from './TriState';

/**
 * @type TrackItDataTypeBooleanDtoValue
 * 
 * @export
 */
export type TrackItDataTypeBooleanDtoValue = TriState;


export function TrackItDataTypeBooleanDtoValueFromJSON(json: any): TrackItDataTypeBooleanDtoValue {
    return TrackItDataTypeBooleanDtoValueFromJSONTyped(json, false);
}

export function TrackItDataTypeBooleanDtoValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataTypeBooleanDtoValue {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TriStateFromJSONTyped(json, true) };
    return  TriStateFromJSONTyped(json, true);
}

export function TrackItDataTypeBooleanDtoValueToJSON(value?: TrackItDataTypeBooleanDtoValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTriState(value)) {
        return TriStateToJSON(value as TriState);
    }

    return {};
}

/**
 * Check if a given object implements the TrackItDataTypeBooleanDtoValue interface.
 */
export function instanceOfTrackItDataTypeBooleanDtoValue(value: any): value is TrackItDataTypeBooleanDtoValue {
    if (instanceOfTriState(value)) return true;
    return false;
}

